import constants from 'app/constants'
import fetchJSONData from 'app/util/fetchJSONData'

/**
 * Get the supply
 *
 * @param {Array} ids - the ids to check for supply against (empty array if want *all* supply)
 * @returns {object} the result data
 */
/* export default async function getSupply (ids = []) {
  return await fetchJSONData(`${constants.API_URL}/nft_element/supply`, {
    method: 'POST',
    body: JSON.stringify({ nft_id: ids, network: constants.NETWORK }),
    headers: {
      'company-id': constants.API_ID,
      'Content-Type': 'application/json'
    }
  })
} */

/**
 * Get the supply
 *
 * @param {Array} ids - the ids to check for supply against (empty array if want *all* supply)
 * @returns {object} the result data
 */
export default async function getSupply () {
  return await fetchJSONData(
    `${constants.API_URL}/nft_element/supply?network=${constants.NETWORK}`,
    {
      method: 'GET',
      headers: {
        'company-id': constants.API_ID,
        'Content-Type': 'application/json'
      }
    }
  )
}
